import script from "./PendingVerifyNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingVerifyNotice.vue?vue&type=script&setup=true&lang=js"

import "./PendingVerifyNotice.vue?vue&type=style&index=0&id=ff03ad02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff03ad02"]])

export default __exports__